import {PaginationArgs, LayerType} from "platformed-client/types";
import {platformedClient} from "..";

export async function list(layerType: LayerType, paginationArgs: PaginationArgs) {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/tasks/{layer_type}`, {
    query: paginationArgs,
    path: {layer_type: layerType},
  });
}

export async function count(layerType: LayerType) {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/tasks/{layer_type}/count`, {
    path: {layer_type: layerType},
  });
}

export async function getGettingStartedChecklist() {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/getting_started_checklist`,
    {},
  );
}
